import React, { useState } from 'react';
import { requestSignInLink } from '../services/auth';
import './SignIn.css';

/**
 * Passwordless sign-in. The person enters an email and receives a one-time
 * link; there is no password to choose, forget, or reset.
 */
function SignIn({ onClose, reason }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      setError('Please enter your email address.');
      return;
    }

    setStatus('sending');
    setError('');
    try {
      await requestSignInLink(trimmed);
      setStatus('sent');
    } catch (err) {
      setStatus('error');
      setError(
        'We could not send the link just now. Please check your connection and try again.'
      );
    }
  };

  return (
    <div className="signin-overlay" role="dialog" aria-modal="true" aria-labelledby="signin-title">
      <div className="signin-backdrop" onClick={onClose} />
      <div className="signin-panel">
        <button type="button" className="signin-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        {status === 'sent' ? (
          <>
            <span className="signin-glyph" aria-hidden="true">✉</span>
            <h3 id="signin-title">Check your email</h3>
            <p className="signin-sub">
              We sent a sign-in link to <strong>{email.trim()}</strong>. Open it
              on any device to sign in — the link works once and expires in
              15 minutes.
            </p>
            <button type="button" className="signin-secondary" onClick={() => setStatus('idle')}>
              Use a different email
            </button>
          </>
        ) : (
          <>
            <span className="signin-glyph" aria-hidden="true">✦</span>
            <h3 id="signin-title">Sign in to Astrobot</h3>
            <p className="signin-sub">
              {reason === 'subscription'
                ? 'Sign in so your subscription and charts follow you to every device.'
                : 'No password needed. We will email you a link that signs you in.'}
            </p>

            <form onSubmit={submit}>
              <input
                type="email"
                className="signin-input"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError('');
                }}
                placeholder="you@example.com"
                autoComplete="email"
                autoFocus
                disabled={status === 'sending'}
              />

              {error && <div className="signin-error" role="alert">{error}</div>}

              <button
                type="submit"
                className="signin-cta"
                disabled={status === 'sending' || !email.trim()}
              >
                {status === 'sending' ? 'Sending…' : 'Email me a sign-in link'}
              </button>
            </form>

            <p className="signin-note">
              Your charts stay on this device until you sign in.
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default SignIn;
